<template>
    <div ref="gantt"></div>
</template>

<script>
  import moment from 'moment'
  import {gantt} from 'dhtmlx-gantt';
  import axios from "axios";

  export default {
    name: 'gantt',
    props: {
      tasks: {
        type: Object,
        default () {
          return {
            data: [],
            links: []
          }
        }
      },
      rowData: {
        type: Array,
        default: () => ([])
      },
      projectPermission: {
        type: Object,
        default: () => ({
          updateTask: true
        })
      }
    },
    data () {
      return {
        moment: moment,
        value: null
      }
    },
    mounted(){
      this.initChart()
    },
    methods:{
      initChart() {
        gantt.config.open_tree_initially = true;
        gantt.config.xml_date = "%Y-%m-%d";
        // disable links
        gantt.config.drag_links = false;
        //disable task creation
        gantt.config.lightbox = false;
        gantt.config.drag_progress = false;

        // ADD FILTERING START
        let filterValue = "";
        let delay;
        // gantt.$doFilter = function(value){
        //   filterValue = value;
        //   clearTimeout(delay);
        //   delay = setTimeout(function(){
        //     gantt.render();
        //     gantt.$root.querySelector("[data-text-filter]").focus();
        //   }, 200)
        // }
        // let leftLimit = new Date(2020, 9 ,1), rightLimit = new Date(2020, 10 ,28);
        //
        // console.log('leftLimit', leftLimit)
        // console.log('rightLimit', rightLimit)
        // console.log('start_date', this.tasks.data[0].start_date)
        // console.log('math ceil duration', Math.ceil(this.tasks.data[0].duration))
        // console.log('duration', this.tasks.data[0].duration)
        gantt.config.scales = [
          { unit: "day", step: 1, format: "%j %D '%y" }
        ]
        // gantt.config.autosize = "xy";
        const project = this.tasks.data.find(val => val.id === 'project')
        console.log('project', project)
        let projectStart = new Date(project.start_date)
        let projectEnds = new Date(moment(project.deadline_date, "DDMMYYYY").add(1, 'days').format('YYYY-MM-DD'));
        console.log('projectStart', projectStart)
        console.log('projectEnds', projectEnds)
        gantt.attachEvent("onTaskDrag", function(id, mode, task, original){
          let modes = gantt.config.drag_mode;
          if(mode == modes.move || mode == modes.resize){

            let diff = original.duration*(1000*60*60*24);

            if(+task.end_date > +projectEnds){
              task.end_date = new Date(projectEnds);
              if(mode == modes.move)
                task.start_date = new Date(task.end_date - diff);
            }
            if(+task.start_date < +projectStart){
              task.start_date = new Date(projectStart);
              if(mode == modes.move)
                task.end_date = new Date(+task.start_date + diff);
            }
          }
        });

        gantt.attachEvent("onBeforeTaskDrag", (id, mode, e) => {
          if(id === 'project'){
            return false
          }

          const task = this.rowData.find(val => val.id == id)

          if (!task.access) {
            return false
          }

          return this.projectPermission.updateTask
        });

        gantt.$doFilter2 = function(value) {
          filterValue = value;
          clearTimeout(delay);
          delay = setTimeout(function(){
            gantt.render();
          }, 200)
        }

        gantt.attachEvent("onBeforeTaskDisplay", function(id, task){
          if(!filterValue || filterValue == 'All') return true;

          // var normalizedText = task.text.toLowerCase();
          // var normalizedValue = filterValue.toLowerCase();
          if (task.priority == filterValue){
            return true;
          } else {
            return false
          }
          // return normalizedText.indexOf(normalizedValue) > -1;

        });
        // gantt.attachEvent("onGanttRender", function(){
        //   gantt.$root.querySelector("[data-text-filter]").value = filterValue;
        // })

        // const textFilter = "<input data-text-filter type='text' oninput='gantt.$doFilter(this.value)'>"
        gantt.config.autofit = true
        gantt.config.grid_elastic_columns = false;
        gantt.config.grid_width = 500;
        gantt.config.columns = [
          // {name: "text", label: textFilter, tree: true, width: '*', resize: true},
          {name:"text", label:"Task name",  tree:true, width: 300, resize: true },
          {
            name:"start_date", label:"Start Date", align: "center", template:function(obj) {
              return moment(obj.start_date).format("DD MMM YYYY")
            },
            width: 100
          },
          // {name:"end_date", label:"End Date", align: "center" },
          {name:"duration", label:"Duration", align: "center" },
          {name:"status", label:"Status", width: 80, align: "center", template:function(obj) {
              if (obj.status === 'inProgress') obj.status = 'In Progress'
              return obj.status.charAt(0).toUpperCase() + obj.status.slice(1);
            } } ];
        // ADD FILTERING END

        // MOVE TASK EVENT START 1
        gantt.attachEvent("onBeforeTaskChanged", (id, mode, original_task) => {
          const task = gantt.getTask(id);
          console.log('original_task', Object.assign({}, original_task))
          console.log('task', Object.assign({}, task))
          console.log(moment(task.start_date).format('DDMMYYYY'), moment(original_task.start_date).format('DDMMYYYY'))
          if (moment(task.start_date).format('DDMMYYYY') === moment(original_task.start_date).format('DDMMYYYY') && task.duration === original_task.duration ||
              moment(task.end_date).format('DDMMYYYY') === moment(original_task.end_date).format('DDMMYYYY') && task.duration === original_task.duration) {
            return false
          }
          this.$confirm(`${this.$t('modal_editTask')}?`, this.$t('general_info'), {
            confirmButtonText: this.$t('general_ok'),
            cancelButtonText: this.$t('general_cancel'),
            type: 'info'
          }).then(() => {
            const data = {
              'startDate': moment(task.start_date).format('DDMMYYYY'),
              'deadlineDate': moment(task.end_date).subtract(1, "days").format('DDMMYYYY'),
              'projectId': Number(this.$route.query.projectId),
              'taskId': id
            };
            this.$emit('setNewDates', data)
          }).catch(() => {
            task.start_date = gantt.copy(original_task.start_date);
            task.end_date = gantt.copy(original_task.end_date);
            gantt.updateTask(id);
          });
          return true
        });
        // MOVE TASK EVENT END 1

        // MOVE TASK EVENT START 2
        // gantt.attachEvent("onAfterTaskUpdate", (id,item) => {
        //   console.log('onAfterTaskUpdate', id,item)
        //   const data = {
        //     'startDate': moment(item.start_date).format('DDMMYYYY'),
        //     'deadlineDate': moment(item.end_date).format('DDMMYYYY'),
        //     'projectId': Number(this.$route.query.projectId),
        //     'taskId': id
        //   };
        //   this.$emit('setNewDates', data)
        // });
        // MOVE TASK EVENT END 2

        let zoomConfig = {
          levels: [
            {
              name:"day",
              scale_height: 27,
              min_column_width:80,
              scales:[
                {unit: "day", step: 1, format: "%d %M"}
              ]
            },
            {
              name:"week",
              scale_height: 50,
              min_column_width:50,
              scales:[
                {unit: "week", step: 1, format: function (date) {
                    var dateToStr = gantt.date.date_to_str("%d %M");
                    var endDate = gantt.date.add(date, 6, "day");
                    var weekNum = gantt.date.date_to_str("%W")(date);
                    return "#" + weekNum + ", " + dateToStr(date) + " - " + dateToStr(endDate);
                  }},
                {unit: "day", step: 1, format: "%j %D"}
              ]
            },
            {
              name:"month",
              scale_height: 50,
              min_column_width:120,
              scales:[
                {unit: "month", format: "%F, %Y"},
                {unit: "week", format: "Week #%W"}
              ]
            },
            {
              name:"quarter",
              height: 50,
              min_column_width:90,
              scales:[
                {unit: "month", step: 1, format: "%M"},
                {
                  unit: "quarter", step: 1, format: function (date) {
                    var dateToStr = gantt.date.date_to_str("%M");
                    var endDate = gantt.date.add(gantt.date.add(date, 3, "month"), -1, "day");
                    return dateToStr(date) + " - " + dateToStr(endDate);
                  }
                }
              ]},
            {
              name:"year",
              scale_height: 50,
              min_column_width: 30,
              scales:[
                {unit: "year", step: 1, format: "%Y"}
              ]}
          ]
        };

        gantt.ext.zoom.init(zoomConfig);


        gantt.init(this.$refs.gantt);
        gantt.parse(this.$props.tasks);
      },
      changePriority(val){
        // console.log(val)
        // console.log('this.$refs.gantt', this.$refs.gantt)
        // console.log(gantt)
        gantt.$doFilter2(val)
      },
      closeGantt(){
        gantt.clearAll()
        gantt.resetLayout();
      },
      doZooming(value){
        gantt.ext.zoom.setLevel(value);
      }
    }
  }
</script>

<style>
    @import "~dhtmlx-gantt/codebase/dhtmlxgantt.css";
    .gantt_task_content {
      text-align: left;
      padding-left: 20px;
    }
</style>
